import { render, staticRenderFns } from "./PanelRegisterWide.vue?vue&type=template&id=3f6e994a&"
import script from "./PanelRegisterWide.vue?vue&type=script&lang=js&"
export * from "./PanelRegisterWide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports